import { CONFLUENCE_GENERATOR_ID, JIRA_GENERATOR_ID } from '../../constants';
const isConfluenceProvider = provider => provider === CONFLUENCE_GENERATOR_ID;
const isJiraProvider = provider => provider === JIRA_GENERATOR_ID;
const isNativeProvider = provider => isConfluenceProvider(provider) || isJiraProvider(provider);

/**
 * Represents an icon. Should either contain a label and url, or a an icon type and label.
 */

/**
 * Options required to prioritise which icon to show
 */

/**
 * Reusable priority function for choosing which icon to show.
 * Generic so it can be used to prioritise strings, or React components depending on the usage.
 */
export function prioritiseIcon({
  providerId,
  fileFormatIcon,
  documentTypeIcon,
  urlIcon,
  providerIcon
}) {
  if (isNativeProvider(providerId)) {
    return fileFormatIcon || documentTypeIcon || urlIcon || providerIcon;
  }
  return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}